import React from 'react'
import PropTypes from 'prop-types'
import useDepartments from 'support/hooks/use-departments'
import useDepartment from 'support/hooks/use-department'
import useDepartmentId from 'support/hooks/use-department-id'
import useSelectedDepartmentIds from 'support/hooks/use-selected-department-ids'

function GlobalTabletDepartmentFilter (props) {
  const [department, setDepartment] = useDepartment()
  const [departmentIds, setDepartmentIds] = useSelectedDepartmentIds()
  const [defaultDepartmentId] = useDepartmentId()
  const [value, setValue] = React.useState(defaultDepartmentId)

  const [departments] = useDepartments()

  React.useEffect(() => {
    if (value === null) {
      setDepartment(null)

      const allIds = []

      departments.forEach(departmentEntry => {
        allIds.push(departmentEntry.id)
      })

      setDepartmentIds(allIds)
    } else {
      setDepartmentIds([value])

      const currentlySelectedDepartmentId = department !== null ? department.id : null

      if (parseInt(currentlySelectedDepartmentId) !== parseInt(value)) {
        departments.forEach(departmentEntry => {
          if (parseInt(departmentEntry.id) === parseInt(value)) {
            setDepartment(departmentEntry)
          }
        })
      }
    }
  }, [value])

  return null
}

GlobalTabletDepartmentFilter.defaultProps = {
  label: null,
  placeholder: null
}

GlobalTabletDepartmentFilter.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  icon: PropTypes.node
}

export default GlobalTabletDepartmentFilter
